document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".c-article-area");

  sections.forEach((section) => {
    const tabs = section.querySelectorAll(".c-article-area__tab");
    const grids = section.querySelectorAll(".c-article-area__grid");

    function showYear(year) {
      grids.forEach((grid) => {
        grid.style.display = grid.dataset.yearGroup === year ? "grid" : "none";
      });
      tabs.forEach((tab) => {
        tab.classList.toggle("active", tab.dataset.year === year);
      });
    }

    if (tabs.length > 0) {
      showYear(tabs[0].dataset.year);
    }

    tabs.forEach((tab) => {
      tab.addEventListener("click", function () {
        showYear(this.dataset.year);
      });
    });
  });
});
